"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Utilities_1 = require("../../Utilities");
var Check_1 = require("../../Check");
var Check_styles_1 = require("../Check/Check.styles");
var DetailsRowCheck_styles_1 = require("./DetailsRowCheck.styles");
var getCheckClassNames = Utilities_1.classNamesFunction({
    disableCaching: true
});
var getClassNames = Utilities_1.classNamesFunction({
    disableCaching: true
});
var DetailsRowCheckBase = function (props) {
    var _a = props.isVisible, isVisible = _a === void 0 ? false : _a, _b = props.canSelect, canSelect = _b === void 0 ? false : _b, _c = props.isSelected, isSelected = _c === void 0 ? false : _c, _d = props.anySelected, anySelected = _d === void 0 ? false : _d, _e = props.selected, selected = _e === void 0 ? false : _e, _f = props.isHeader, isHeader = _f === void 0 ? false : _f, className = props.className, checkClassName = props.checkClassName, styles = props.styles, theme = props.theme, compact = props.compact, onRenderDetailsCheckbox = props.onRenderDetailsCheckbox, useFastIcons = props.useFastIcons, // must be removed from buttonProps
    buttonProps = tslib_1.__rest(props, ["isVisible", "canSelect", "isSelected", "anySelected", "selected", "isHeader", "className", "checkClassName", "styles", "theme", "compact", "onRenderDetailsCheckbox", "useFastIcons"]);
    var defaultCheckboxRender = useFastIcons ? _fastDefaultCheckboxRender : _defaultCheckboxRender;
    var onRenderCheckbox = onRenderDetailsCheckbox || defaultCheckboxRender;
    var isPressed = isSelected || selected;
    var checkStyles = useFastIcons ? undefined : Check_styles_1.getStyles({ theme: theme });
    var checkClassNames = useFastIcons
        ? undefined
        : getCheckClassNames(checkStyles, {
            theme: theme
        });
    var classNames = getClassNames(styles, {
        theme: theme,
        canSelect: canSelect,
        selected: isPressed,
        anySelected: anySelected,
        className: className,
        isHeader: isHeader,
        isVisible: isVisible,
        compact: compact,
        useGlobalCheckHostClass: useFastIcons
    });
    var detailsCheckboxProps = {
        checked: isPressed,
        theme: theme
    };
    return canSelect ? (React.createElement("div", tslib_1.__assign({}, buttonProps, { role: "checkbox", className: Utilities_1.css(classNames.root, classNames.check, checkClassNames && checkClassNames.checkHost), "aria-checked": isPressed, "data-selection-toggle": true, "data-automationid": "DetailsRowCheck" }), onRenderCheckbox(detailsCheckboxProps, defaultCheckboxRender))) : (React.createElement("div", tslib_1.__assign({}, buttonProps, { className: Utilities_1.css(classNames.root, classNames.check) })));
};
function _defaultCheckboxRender(checkboxProps) {
    return React.createElement(Check_1.Check, { checked: checkboxProps.checked });
}
function _fastDefaultCheckboxRender(checkboxProps) {
    return Check_1.getCheck(checkboxProps.theme, checkboxProps.checked);
}
exports.DetailsRowCheck = Utilities_1.styled(DetailsRowCheckBase, DetailsRowCheck_styles_1.getStyles, undefined, { scope: 'DetailsRowCheck' }, true);
//# sourceMappingURL=DetailsRowCheck.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DetailsList/DetailsRowCheck.js
// module id = 897
// module chunks = 0